import { LocationSearchParamsOption, searchUsingPlacesAPI } from "../_services/city-search.service";
import { IP_DATA_KEY, COOKIES, DefaultCookieOptions } from "_constants/misc";
import { CitySearchResultWithCateg, PlaceSearchResultWithCateg } from "../custom-types/location-search";
import { toast } from "../components/toast/toast";
import { Cookies } from "react-cookie";

function getSavedLoc() {
    const cookies = new Cookies();
    const savedLocString = cookies.get(COOKIES.currentLoc);
    if (!savedLocString) {
        return;
    }
    const { time, ...savedLoc } = savedLocString;
    if (time + 1.5 * 60 * 60 * 1000 < Date.now()) {
        return;
    }
    return savedLoc;
}

export async function getCurrentLocation(
    showToastOnFailure = true,
    option: LocationSearchParamsOption
): Promise<any | undefined> {
    const cookies = new Cookies();
    try {
        const savedLoc = getSavedLoc();
        if (savedLoc) {
            return {
                city: savedLoc.city,
                name: savedLoc.description,
                description: savedLoc.description,
                state: savedLoc.state,
                place_id: savedLoc.place_id
            };
        }
        const locDataRes = await fetch(`https://api.ipdata.co?api-key=${IP_DATA_KEY}`);
        if (locDataRes.status === 200) {
            const locData = await locDataRes.json();
            const currLocArray: PlaceSearchResultWithCateg[] = await searchUsingPlacesAPI(locData.city, {
                ...option,
                suppressErrorToast: true
            });
            if (currLocArray.length !== 0) {
                cookies.set(COOKIES.currentLoc, JSON.stringify({ ...currLocArray[0], time: Date.now() }), {
                    ...DefaultCookieOptions,
                    maxAge: 24 * 60 * 60
                });
                return {
                    ...currLocArray[0],
                    name: currLocArray[0].description
                };
            }
        } else {
            const error = {
                code: 403,
                message: "An error occurred. Please try searching for your location."
            };

            throw error;
            // throw "An error occurred. Please try searching for your location.";
        }
    } catch (e: any) {
        showToastOnFailure && toast.error(e.message);
        return { status: "failed" } as CitySearchResultWithCateg;
    }
}
